/**
 * TEMPORARY FEATURE — Fair Cab Allocation Simulator
 *
 * To remove this feature:
 *   1. Delete this entire folder (src/pages/FairCabSimulator/)
 *   2. Remove the import + spread of FairCabSimulatorConfig in src/pages/index.js
 *   3. Remove the 'fairCabSimulator' entry in src/pages/routesConfig.js
 *   4. Remove the 'fairCabSimulator' key from src/@api/index.js
 */
import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const SimulatorPage = React.lazy(() => import('./SimulatorPage'));

export const FairCabSimulatorConfig = [
  {
    permittedRole: RoutePermittedRole.all,
    path: '/tools/fair-cab-simulator',
    element: <SimulatorPage />,
  },
];
